
    export default {
        data() {
            return {
                products: [
                    {
                        title: "SemaConnect",
                        desc1: "Series 5 - Multifamily",
                        desc2: "Series 6 - Commercial",
                        desc3: "Series 7 - Fleets",
                        desc4: "Series 8 - Retail",
                        img: "Series-7-with-Holsters-top-only1.png",
                        link: "https://semaconnect.com/products/",
                        alt: "SemaConnect EV Charger - Series 7"
                    },
                    {
                        title: "Clipper Creek",
                        desc1: "AmazingE Series",
                        desc2: "LCS Series",
                        desc3: "LHS Series",
                        desc4: "Share2 Series",
                        img: "Clipper-Creek1.png",
                        link: "https://semaconnect.com/products/",
                        alt: "Clipper Creek EV Charger - AmazingE Series"
                    },
                    {
                        title: "Charge Point",
                        desc1: "Express - DCFS",
                        desc2: "Express Plus - Scalable DCFS",
                        desc3: "CT4000 - All-Purpose",
                        desc4: "CPF50 - Fleets & Multifamily",
                        img: "CP-Express.png",
                        link: "https://www.chargepoint.com/products/commercial",
                        alt: "Charge Point EV Charger - Express",
                    },
                    {
                        title: "Leviton",
                        desc1: "EVR Series",
                        desc2: "Wall Mount Station",
                        desc3: "Bollard Station",
                        desc4: "CPDCF - Public",
                        img: "EVR30-B1C.png",
                        link: "https://www.leviton.com/en/all-products-new/ev-charging/evse-charging#t=Products&sort=%40wcs_site_tree_rank%20ascending&layout=card&f:@tsa_device_type=[Charger]",
                        alt: "Leviton EV Charger - EVR Series"
                    },
                ]
            }
        },
    };
